<template>
<div>
  <Modal :value="true" :width="width"   :mask-closable="false" :closable="false" :transfer="transfer" :footer-hide="footerHide">
    <div slot="header" class="header">
      <span class="title">{{title}}</span>
      <Icon type="ios-close" @click="close" size="32"/>
    </div>
    <slot/>
    <div slot="footer">
      <Button @click="close">{{cancelText}}</Button>
      <Button type="primary" @click="confirm" class=" ml-20">{{confirmText}}</Button>
   </div>
  </Modal>
</div>
</template>

<script>
import dialog from '@/mixins/dialog';
export default {
  mixins: [dialog],
  props: {
    /**
     * 取消文字
     */
    cancelText: {
      type: String,
      default: '取消'
    },
    /**
     * 确定文字
     */
    confirmText: {
      type: String,
      default: '确定'
    },
    /**
     * 是否隐藏footer
     */
    footerHide: {
      type: Boolean,
      default: false
    },
    transfer: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /**确定 */
    confirm() {
      this.$emit('confirm')
    },

  }
}
</script>

<style scoped>
.header{
  display: flex;
  justify-content: space-between;
}
.header .title{
  font-size: 22px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/BaseModal/index.vue?521c5e34